export class ImagerBurst {
    constructor(duration) {
        this.duration = duration;
    }
}
export class TriggerImagerAction {
    constructor(duration) {
        this.name = 'TriggerImager';
        this.isDeviceAction = true;
        this.data = {};
        this.data.duration = duration;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJpZ2dlckltYWdlckFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWxzL2FjdGlvbnMvVHJpZ2dlckltYWdlckFjdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNQSxNQUFNLE9BQU8sV0FBVztJQUd0QixZQUFZLFFBQWdCO1FBQzFCLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDO0lBQzNCLENBQUM7Q0FDRjtBQUtELE1BQU0sT0FBTyxtQkFBbUI7SUFLOUIsWUFBWSxRQUFnQjtRQUpaLFNBQUksR0FBRyxlQUFlLENBQUM7UUFDdkIsbUJBQWMsR0FBRyxJQUFJLENBQUM7UUFDL0IsU0FBSSxHQUFnQyxFQUFFLENBQUM7UUFHNUMsSUFBSSxDQUFDLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDO0lBQ2hDLENBQUM7Q0FDRiJ9